import { render } from "./LayoutHome.vue?vue&type=template&id=340d64d7"
import script from "./LayoutHome.vue?vue&type=script&lang=js"
export * from "./LayoutHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__